module.exports = __webpack_public_path__ + "media/images/background/background-login-caa4df36b3dd4f6ba2a93bc797f3a784.png";